import { API } from "@/components/_Shared/API/API";
import { AxiosInstance } from "../components/Axios"
import { AssignmentProps } from "../interfaces/assignment_types";
import { APIResponse } from "@/components/_Shared/API/API";

export async function createAssignment(assignment: AssignmentProps): Promise<APIResponse> {
    const response = await API.post<void>("api/assignment/", assignment)
    return response
}

export async function updateAssignment(assignment: AssignmentProps): Promise<APIResponse> {
    const response = await API.put<void>(`api/assignment/id/${assignment.id}`, assignment)
    return response
}

export async function deleteAssignment(assignment: AssignmentProps): Promise<APIResponse> {
    const response = await API.delete<void>(`api/assignment/id/${assignment.id}`)
    return response
}

export async function getAssignmentById(assignmentId: string): Promise<AssignmentProps> {
    const response = await AxiosInstance.get(`api/assignment/id/${assignmentId}`)
    return response.data
}

export async function getAssignments(params?: {query?: string}): Promise<AssignmentProps[]> {
    const response = await AxiosInstance.get("api/assignment/", {params})
    return response.data
}

export async function getAssignmentsByUser(userId: string): Promise<AssignmentProps[]> {
    const response = await AxiosInstance.get(`api/assignment/user/${userId}`)
    return response.data
}


export async function markAssignmentAsClosed(assignmentId: string): Promise<number> {
    const response = await AxiosInstance.put(`api/assignment/mark_as_closed/${assignmentId}`)
    return response.status
}

